import React, { useState } from 'react';
import ambulanceImage from '../assets/img/ambulance-4.png';

function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "What types of medical emergencies do you handle?",
      answer:
        "We provide ambulance services for all types of medical emergencies, including road accidents, cardiac arrests, stroke cases, and non-emergency patient transfers.",
    },
    {
      question: "Do your ambulances have trained medical staff onboard?",
      answer:
        "Yes, our ambulances are staffed with experienced paramedics, emergency medical technicians (EMTs), and, when required, doctors to provide immediate care during transit.",
    },
    {
      question: "Can I book an ambulance for a non-emergency medical transfer?",
      answer:
        "Absolutely! We offer non-emergency patient transportation for hospital visits, medical checkups, and intercity transfers with well-equipped ambulances.",
    },
    {
      question: "Are your ambulance services available in remote areas?",
      answer:
        "Yes, we strive to reach even the most remote areas with our extensive network of ambulances stationed strategically across cities and rural locations.",
    },
  ];

  return (
    <section className="faq-section">
      <img className="container-back-img" src={ambulanceImage} alt="ambulance" />
      <div className="container">
        <div className="faq-container">
          <h1 className="fade-out fade-in ">Frequently Asked Questions (FAQ)</h1>
          <h6 className="fade-out fade-in ">
            Get answers to common queries about our emergency ambulance services available 24/7 across India.
          </h6>

          {faqItems.map((item, index) => (
            <div className={`faq-item ${activeIndex === index ? 'active' : ''}`} key={index}>
              <button
                className="faq-question fade-out fade-in "
                onClick={() => toggleFaq(index)}
              >
                <i className="fas fa-plus"></i> {item.question}
              </button>
              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
